export default __webpack_public_path__ + "static/media/beforeafter.8c1b4393.png";